<template>
  <div class="ima-footer">
  </div>
</template>

<script>
export default {
  name: 'ima-footer',
  data () {
    return {}
  }
}
</script>


<style scoped lang="scss">
.ima-footer {
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue